import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { TipDialogData } from './tip-dialog';

@Component({
  selector: 'valg-tip-dialog',
  templateUrl: './tip-dialog.component.html',
  styleUrls: [ './tip-dialog.component.scss' ]
})
export class TipDialogComponent {
  SvgIcon = SvgIcon;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: TipDialogData
  ) { }

}